module.exports = __webpack_public_path__ + "img/intro_tips_sz.fd6b1f29.png";